import { useTranslation } from 'react-i18next'
import { ProgressSpinner } from 'primereact/progressspinner'
import Button from '../components/ui/Button'

interface AuthLoadingProps {
  /** react-oidc-context hata mesajı (varsa) → recovery ekranı. */
  error?: string
  /** "Tekrar dene" → hatayı temizleyip yeniden giriş başlatır (giriş fiilen mümkünken anlamlı). */
  onRetry?: () => void
  /**
   * Giriş için gereken PKCE digest yeteneği (`crypto.subtle`) yok: güvensiz bağlamda (HTTP + IP)
   * polyfill de kurulamadı (ör. `crypto` hiç yok / `subtle` yeniden tanımlanamadı). Nadir; bu durumda
   * giriş başlatılamaz → retry doomed olduğundan buton yerine "HTTPS'e taşıyın" uyarısı gösterilir.
   */
  insecure?: boolean
}

/**
 * Kimlik doğrulama sürerken nötr yükleme; hata/giriş-imkânsız durumda ise **çıkmaz değil** recovery
 * ekranı (FR-014). Giriş için gereken `crypto.subtle` (PKCE digest) hem native hem polyfill sonrası
 * yoksa retry doomed olduğundan buton yerine HTTPS uyarısı gösterilir; transient hatada ise
 * "Tekrar dene" ile kullanıcı yeniden giriş başlatabilir.
 */
export default function AuthLoading({ error, onRetry, insecure }: Readonly<AuthLoadingProps>) {
  const { t } = useTranslation()

  if (!error && !insecure) {
    return (
      <div className="auth-loading" role="status" aria-live="polite">
        <ProgressSpinner strokeWidth="4" style={{ width: 48, height: 48 }} />
        <p>{t('auth.loading')}</p>
      </div>
    )
  }

  return (
    <div className="auth-loading auth-loading--error" role="alert">
      <p>{insecure ? t('auth.insecureContext') : t('auth.error')}</p>
      {/* crypto.subtle yoksa (polyfill de yok) giriş başlatılamaz → retry doomed, gösterme (yanıltıcı olur). */}
      {!insecure && onRetry && <Button label={t('auth.retry')} onClick={onRetry} />}
    </div>
  )
}
